import type { CSSProperties } from "react";

/** Desk DataTable column meta — plan/34. */
export type DeskColumnMeta = {
  /** Cell + header alignment. Use `right` for money (and other numeric) columns. */
  align?: "left" | "right" | "center";
};

export function columnAlign(
  meta: unknown,
): DeskColumnMeta["align"] | undefined {
  if (!meta || typeof meta !== "object") return undefined;
  const align = (meta as DeskColumnMeta).align;
  if (align === "left" || align === "right" || align === "center") return align;
  return undefined;
}

export function alignClass(align: DeskColumnMeta["align"] | undefined): string {
  if (align === "right") return "text-right";
  if (align === "center") return "text-center";
  return "";
}

/**
 * Proportional column width for `table-layout: fixed` + `width: 100%`.
 * TanStack `size` values are share weights (and resize targets), not a
 * table min-width — keeps the card inside the desk column so filters/title
 * align, without nested `overflow-x` (which breaks page-scroll sticky thead).
 */
export function columnShareStyle(
  size: number,
  totalSize: number,
): CSSProperties {
  if (!(totalSize > 0) || !(size >= 0)) return {};
  return { width: `${(size / totalSize) * 100}%` };
}
